import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import { store } from './_store';
import { App } from './App';
import { UserContextProvider } from './context/UserContext'; // Import UserProvider
import './index.css';
import { GoogleOAuthProvider } from '@react-oauth/google';

// setup fake backend
// import { fakeBackend } from './_helpers';
// fakeBackend();
const msalInstance = new PublicClientApplication(msalConfig);
const container = document.getElementById('root');
const root = createRoot(container);
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

root.render(
    // <React.StrictMode>
    <GoogleOAuthProvider clientId={clientId}>
        <Provider store={store}>
          <MsalProvider instance={msalInstance}>
         <UserContextProvider> 
            <BrowserRouter>
                <App />
            </BrowserRouter>
            </UserContextProvider>
            </MsalProvider>
        </Provider>
        </GoogleOAuthProvider>
    // </React.StrictMode>
);
<div className="home-container">
  <div className="home-content">...</div>
  <div className="home-sidebar-wrapper">
    <div className="home-sidebar">
      {/* your step boxes here */}
    </div>
  </div>
</div>

